export const step = [
  {
    title: '阅读须知',
    name: 'read',
    permission: 'IEBDC:SQ:YDXZ',
  },
  //   {
  //     title: '申请类型',
  //     name: 'applicantTypeContainer',
  //     permission: 'IEBDC:SQ:DJLX1' // 申请类型为新设计合并流程，权限暂时用之前的登记类型
  //   },
  {
    title: '产权证核验',
    name: 'rightCertify',
    permission: 'IEBDC:SQ:CQZHY',
    code: [
      'N300104',
      'N500104',
      'N400104',
      'N400301',
      'N100301',
      'N200301',
      'N300301',
      'N300126',
      'N360099',
      'N360000',
      'N100203',
      'H999003', //合并流程（变更+转移）
      'H999002', //合并流程（转移+抵押）
      'N200111',
      'N100303',
      'N100402',
      'N300099',
      'N300103', // 土地变更
      'N123412', //二手房预告
      'H100301',
    ],
    personCode: [
      'N100402',
      // 'H999001', //个人用户合并流程（预告买卖+预告抵押）
      // 'N100201', // 个人用户预售商品房买卖预告登记
      //'H999002', //个人用户合并流程（转本位）
      'N200104', //个人用户转移登记
    ],
  },
  {
    title: '楼盘表提取',
    name: 'showHouseTable',
    permission: 'IEBDC:SQ:LPBTQ',
    code: ['N300098']
    // code: ['N100104'],
    // companyCode: ['N100201', 'H999001', 'H999002'] // 企业用户使用楼盘表
  },
  {
    title: '填写申请表',
    name: 'applicantTable',
    permission: 'IEBDC:SQ:TXSQB',
  },
  //   {
  //     title: '抵押合同',
  //     name: 'mortgageContract',
  //     permission: 'IEBDC:SQ:DYHT',
  //     code: ['N100301', 'N300301', 'H999001', 'H999002']
  //   },

  {
    title: '材料上传',
    name: 'uploadFile',
    permission: 'IEBDC:SQ:SCFJ',
  },
  {
    title: '身份认证',
    name: 'authorizedCertify',
    permission: 'IEBDC:SQ:SQRZ',
  },
  //   {
  //     title: '智能审核',
  //     name: 'intelligentAudit',
  //     permission: 'IEBDC:SQ:ZNSP',
  //     code: [
  //       'N200104', //房屋所有权转移登记
  //       'N300104', //房屋变更
  //       'N500104', //房屋更正
  //       //'N400104', //注销登记
  //       //'N400301', //抵押权注销登记
  //       'N100301', //抵押权首次登记
  //       'N200301', //房屋抵押权转移登记
  //       'N300301', //房屋抵押权变更登记
  //       //'N300126', //预售商品房抵押权预告注销
  //       //'N360099',
  //       //'N360000', //预售商品房买卖预告注销
  //       'N100203', //预售商品房抵押权预告登记
  //       'H999003', //合并流程（变更+转移）
  //       'H999002', //合并流程（转移+抵押）
  //       'N200111', //土地押权转移登记
  //       //'N100303', //土地押权注销登记
  //       //'N300099',
  //       'H999001', //预告登记+预抵押登记
  //       'N100402', //房屋首次登记

  //       'N100201', //预售商品房买卖预告登记
  //       'N300103' // 土地变更
  //     ]
  //   },
  {
    title: '完成',
    name: 'finish',
    permission: 'IEBDC:SQ:WC',
  },
];
